import {
  getFirstLoginAfterReleaseShopData,
  getTopPageApi,
  putFirstLoginAfterReleaseShopData
} from '../libs/apis/TopPageApi';

export const GET_TOPPAGE_REQUEST = 'GET_TOPPAGE_REQUEST';
export const GET_TOPPAGE_SUCCESS = 'GET_TOPPAGE_SUCCESS';
export const GET_TOPPAGE_FAILURE = 'GET_TOPPAGE_FAILURE';

export const GET_FIRST_LOGIN_AFTER_RELEASE_REQUEST =
  'GET_FIRST_LOGIN_AFTER_RELEASE_REQUEST';
export const GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS =
  'GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS';
export const GET_FIRST_LOGIN_AFTER_RELEASE_FAILURE =
  'GET_FIRST_LOGIN_AFTER_RELEASE_FAILURE';

export const PUT_FIRST_LOGIN_AFTER_RELEASE_REQUEST =
  'PUT_FIRST_LOGIN_AFTER_RELEASE_REQUEST';
export const PUT_FIRST_LOGIN_AFTER_RELEASE_SUCCESS =
  'PUT_FIRST_LOGIN_AFTER_RELEASE_SUCCESS';
export const PUT_FIRST_LOGIN_AFTER_RELEASE_FAILURE =
  'PUT_FIRST_LOGIN_AFTER_RELEASE_FAILURE';

export const getTopPageInfo = params => dispatch => {
  dispatch({ type: GET_TOPPAGE_REQUEST });
  return getTopPageApi(params)
    .then(response =>
      dispatch({
        type: GET_TOPPAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_TOPPAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getFirstLoginAfterReleaseShop = () => dispatch => {
  dispatch({ type: GET_FIRST_LOGIN_AFTER_RELEASE_REQUEST });
  return getFirstLoginAfterReleaseShopData()
    .then(response =>
      dispatch({
        type: GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_FIRST_LOGIN_AFTER_RELEASE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const putFirstLoginAfterReleaseShop = params => dispatch => {
  dispatch({ type: PUT_FIRST_LOGIN_AFTER_RELEASE_REQUEST });
  return putFirstLoginAfterReleaseShopData(params)
    .then(response =>
      dispatch({
        type: PUT_FIRST_LOGIN_AFTER_RELEASE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: PUT_FIRST_LOGIN_AFTER_RELEASE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
